<template>
  <div class="collection-item-box" @click="$modal.open('customer', customer)">
    <h2 class="truncate" v-text="customer.name"></h2>
    <p class="text-sm">{{ customer.company_name ? 'Société' : 'Particulier' }}</p>
    <hr>
    <div class="flex items-center justify-between">
      <vue-tag icon="city-solid">{{ customer.city || '-' }}</vue-tag>
      <vue-tag class="bg-blue-lightest text-blue-light" icon="call-solid">{{ phone || '-'}}</vue-tag>
    </div>
    <template v-if="$can('orders-create')">
      <hr>
      <div class="flex justify-center">
        <vue-button class="btn btn-sm btn-outline btn-primary mt-2"
                    icon="note-list-solid"
                    :status="status"
                    event-modifier="stop"
                    @click="handleOrderClick">Nouvelle commande</vue-button>
      </div>
    </template>
  </div>
</template>

<script>
/* globals route axios */
import { formatPhone } from '../../core/helpers';
import ErrorHandler from '../../core/ErrorHandler';

export default {
  props: {
    customer: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      status: null,
    };
  },

  computed: {
    phone() {
      if (this.customer.mobile_phone || this.customer.home_phone) {
        return formatPhone(
          this.customer.mobile_phone || this.customer.home_phone,
        );
      }
      return '-';
    },
  },

  methods: {
    handleOrderClick() {
      this.status = 'loading';
      axios
        .get(route('api.carts.show', this.customer.id))
        .then(({ data }) => this.onSuccess(data.data))
        .catch(error => this.onFail(error));
    },

    onSuccess(cart) {
      this.status = null;
      this.$modal.open('order', { cart });
    },

    onFail(error) {
      this.status = 'failed';
      new ErrorHandler(error).dispatch();
      setTimeout(() => {
        this.status = null;
      }, 1000);
    },
  },
};
</script>